export const MAX_FILE_SIZE_MB = 5;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const FILE_MAX_SIZE_ERROR = 'file_max_size_error';
export const FILE_TYPE_ERROR = 'file_type_error';

export const TYPE_TO_MIME: Record<string, string> = {
	jpg: 'image/jpg',
	jpeg: 'image/jpeg',
	png: 'image/png',
	pdf: 'application/pdf',
	doc: 'application/msword',
	docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
} as const;

export const SUPPORTED_FILE_MIME = Object.values(TYPE_TO_MIME);
export const SUPPORTED_FILE_TYPES = Object.keys(TYPE_TO_MIME);

export const STRING_SUPPORTED_FILE_MIME = SUPPORTED_FILE_MIME.join(',');
export const STRING_SUPPORTED_FILE_TYPES = SUPPORTED_FILE_TYPES.join(', ');
